export const userHasPhotoActivity = ({ totals }) => {
    if (!totals) return false;

    let result = false;

    if (
        totals.totalEarned !== "0" || // totalEarned comes back as a String
        totals.freeDownloadCount !== 0 ||
        totals.fullResSales !== 0 ||
        totals.largeSales !== 0
    )
        result = true;

    return result;
};
